// import React, { useState, useEffect } from "react";
// import { useGetSoilParametersQuery } from "../RiskManagement/RiskManagementApiSlice";
// import { Card, Badge, Spinner, Button } from "react-bootstrap";
// import FarmerReportGaugeChart from "features/onboarding/users/farmer/FarmerReportGaugeChart";
// import FarmerProgressBarChart from "features/onboarding/users/farmer/FarmerProgressBarChart";
// import RadialSoilScoreChart from "./RadialSoilScoreChart";
// import { useGetFarmersQuery } from "features/onboarding/users/farmer/farmerApiSlice";
// import { skipToken } from "@reduxjs/toolkit/query";
// import { store } from "app/store";
// import axios from "axios";
// import { API_URL } from "app/config";

// export const ProjectAdvisorySection = ({ orgId }) => {
//   const [pagination, setPagination] = useState({ page: 1, per_page: 50 });
//   const [selectedFarmer, setSelectedFarmer] = useState(null);
//   const [SoilDetails, setSoilDetails] = useState([]);
//   const [FarmerData, setFarmerData] = useState(null);
//   const [loading, setIsLoading] = useState(false);
//   const { data: farmerData, isLoading: farmerLoading } = useGetFarmersQuery(
//     { orgId, pagination },
//     { refetchOnMountOrArgChange: true, pollingInterval: 900000 }
//   );

//   const { data: soilData, isLoading: soilLoading } = useGetSoilParametersQuery(
//     selectedFarmer?.id ? { FarmerId: selectedFarmer.id } : skipToken
//   );

//   useEffect(() => {
//     if (farmerData?.data?.results?.length && !selectedFarmer) {
//       const firstFarmer = farmerData.data.results[0];
//       handleSelectFarmer(firstFarmer);
//     }
//   }, [farmerData]);

//   useEffect(() => {
//     setSoilDetails(soilData?.data?.results || []);
//   }, [soilData]);

//   const handleSelectFarmer = async (farmer) => {
//     setSelectedFarmer(farmer);
//     await fetchFarmerData(farmer.id);
//   };

//   const fetchFarmerData = async (farmerId) => {
//     setIsLoading(true);
//     const state = store.getState();
//     try {
//       const response = await axios.get(
//         `${API_URL}/api/v1/onboarding/farmers/${farmerId}`,
//         {
//           headers: {
//             Authorization: `Bearer ${state.auth.accessToken}`,
//             "Content-Type": "application/json",
//           },
//         }
//       );
//       setFarmerData(response?.data?.data?.farm);
//     } catch (error) {
//       console.error("Error fetching farmer data:", error);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   return (
//     <div className="d-flex p-2">
//       <div className="d-flex align-items-start">
//         <div
//           style={{
//             width: "300px",
//             borderRight: "1px solid #e5e5e5",
//             padding: "15px",
//             backgroundColor: "#f9f9f9",
//             height: "auto",
//              flexShrink: 0,
//           }}>
//           <h5 className="mb-3">Farmers</h5>
//           {farmerLoading ? (
//             <div className="text-center p-4">
//               <Spinner animation="border" />
//               <p className="mt-2">Loading farmers...</p>
//             </div>
//           ) : (
//             <>
//               {farmerData?.data?.results?.map((farmer) => (
//                 <div
//                   key={farmer.FarmerId}
//                   onClick={() => handleSelectFarmer(farmer)}
//                   className={`d-flex align-items-center mb-3 p-2 rounded shadow-sm ${
//                     selectedFarmer?.id === farmer.id
//                       ? "bg-primary text-white"
//                       : "bg-white"
//                   }`}
//                   style={{ cursor: "pointer", transition: "0.3s" }}
//                 >
//                   <img
//                     src={
//                       farmer.ImageFile ||
//                       "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSxTYFlL3rMQGJUnGYA--ilSNhGJwCOdYr7kA&s"
//                     }
//                     alt={farmer.full_name}
//                     className="rounded-circle me-3"
//                     style={{
//                       width: "50px",
//                       height: "50px",
//                       objectFit: "cover",
//                     }}
//                   />
//                   <div>
//                     <div className="fw-bold">{farmer.full_name}</div>
//                     <small>{farmer.phone_number}</small>
//                   </div>
//                 </div>
//               ))}
//             </>
//           )}
//           <div className="d-flex justify-content-between mt-4">
//             <Button
//               variant="secondary"
//               size="sm"
//               onClick={() =>
//                 setPagination((prev) => ({
//                   ...prev,
//                   page: Math.max(prev.page - 1, 1),
//                 }))
//               }
//               disabled={pagination.page === 1}>
//               Previous
//             </Button>
//             <span>Page {pagination.page}</span>
//             <Button
//               size="sm"
//               style={{
//                 backgroundColor:
//                   farmerData?.data?.results?.length < pagination.per_page
//                     ? "#6c757d"
//                     : "#ff7f50",
//                 borderColor:
//                   farmerData?.data?.results?.length < pagination.per_page
//                     ? "#6c757d"
//                     : "#ff7f50",
//               }}
//               onClick={() =>
//                 setPagination((prev) => ({ ...prev, page: prev.page + 1 }))
//               }
//               disabled={farmerData?.data?.results?.length < pagination.per_page}
//             >
//               Next
//             </Button>
//           </div>
//         </div>

//         <div className="flex-grow-1 p-3" >
//           <Card className="shadow-sm mb-4">
//             <Card.Header>
//               <h5>{selectedFarmer?.full_name} - Advisory Details</h5>
//             </Card.Header>
//             <Card.Body>
//               <h5 className="mb-3">Soil Parameters</h5>
//               {SoilDetails?.length ? (
//                 SoilDetails.map((plot, index) => (
//                   <div
//                     key={index}
//                     className="mb-4 p-3 border rounded shadow-sm"
//                   >
//                     <div className="d-flex justify-content-between align-items-center mb-3">
//                       <h6 className="mb-0 text-primary">
//                         {plot?.Parameters?.Time || "N/A"}
//                       </h6>
//                     </div>

//                     <div className="row g-3">
//                       <div className="col-md-4">
//                         <div className="border rounded p-2 text-center bg-white">
//                           <small className="text-muted">Moisture</small>
//                           <h5 className="mt-1 text-primary">
//                             {plot?.Parameters?.moisture || "N/A"}%
//                           </h5>
//                         </div>
//                       </div>

//                       <div className="col-md-4">
//                         <div className="border rounded p-2 text-center bg-white">
//                           <small className="text-muted">Temperature</small>
//                           <h5 className="mt-1 text-danger">
//                             {plot?.Parameters?.temperature || "N/A"}°C
//                           </h5>
//                         </div>
//                       </div>

//                       <div className="col-md-4">
//                         <div className="border rounded p-2 text-center bg-white">
//                           <small className="text-muted">EC Value</small>
//                           <h5 className="mt-1 text-success">
//                             {plot?.Parameters?.ecValue || "N/A"}
//                           </h5>
//                         </div>
//                       </div>

//                       <div className="col-md-4">
//                         <div className="border rounded p-2 text-center bg-white">
//                           <small className="text-muted">pH Value</small>
//                           <h5 className="mt-1">
//                             {plot?.Parameters?.pHValue || "N/A"}
//                           </h5>
//                         </div>
//                       </div>

//                       <div className="col-md-8">
//                         <div className="border rounded p-2 bg-white">
//                           <small className="text-muted d-flex justify-content-center">
//                             NPK Values
//                           </small>
//                           <div className="mt-2 d-flex gap-2 justify-content-center">
//                             <Badge bg="primary" className="f14">
//                               N : {plot?.Parameters?.nValue || "N/A"}
//                             </Badge>
//                             <Badge bg="success" className="f14">
//                               P : {plot?.Parameters?.pValue || "N/A"}
//                             </Badge>
//                             <Badge bg="warning" text="dark" className="f14">
//                               K : {plot?.Parameters?.kValue || "N/A"}
//                             </Badge>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 ))
//               ) : (
//                 <div className="text-center text-muted p-4 border rounded w-full">
//                   No Soil Data Available
//                 </div>
//               )}
//               <h5 className="mt-5 mb-3">Scores</h5>
//               {FarmerData?.length ? (
//                 FarmerData?.map((farm, idx) => (
//                   <div key={idx} className="row mb-4 border rounded p-3">
//                     <h6>
//                       Plot {idx + 1} - {farm?.SurveyNo}
//                     </h6>
//                     <div className="col-md-4 text-center">
//                       <RadialSoilScoreChart
//                         value={farm?.summary_stats?.soil_score || 0}
//                         label="Soul Score"
//                       />
//                     </div>
//                     <div className="col-md-4 text-center">
//                       <FarmerReportGaugeChart
//                         farmerDataCl={farm?.summary_stats?.acs}
//                         chartName="Agriculture Credit Score"
//                       />
//                     </div>
//                     <div className="col-md-4 text-center">
//                       <FarmerProgressBarChart
//                         farmerDataCl={farm?.summary_stats?.crop_health}
//                         chartName="Crop Health Score"
//                       />
//                     </div>
//                   </div>
//                 ))
//               ) : (
//                 <div className="text-muted">No score data available</div>
//               )}
//             </Card.Body>
//           </Card>
//         </div>
//       </div>
//     </div>
//   );
// };

import React, { useState, useEffect } from "react";
import { useGetSoilParametersQuery } from "../RiskManagement/RiskManagementApiSlice";
import { Card, Badge, Spinner, Button, Modal } from "react-bootstrap";
import FarmerReportGaugeChart from "features/onboarding/users/farmer/FarmerReportGaugeChart";
import FarmerProgressBarChart from "features/onboarding/users/farmer/FarmerProgressBarChart";
import RadialSoilScoreChart from "./RadialSoilScoreChart";
import { useGetFarmersQuery } from "features/onboarding/users/farmer/farmerApiSlice";
import { skipToken } from "@reduxjs/toolkit/query";
import { store } from "app/store";
import axios from "axios";
import { API_URL } from "app/config";
import { CardBody, CardHeader, Table } from "reactstrap";
import FarmerCropHealthMap from "features/onboarding/users/farmer/FarmerCropHealthMap";
import { AdvisoryTextComponent } from "./AdvisoryTextComponent";
import { Visibility } from "@mui/icons-material";
import { useMediaQuery } from "@mui/system";

export const ProjectAdvisorySection = ({ orgId, AdvisoryUrl }) => {
  const [pagination, setPagination] = useState({ page: 1, per_page: 50 });
  const [selectedFarmer, setSelectedFarmer] = useState(null);
  const [SoilDetails, setSoilDetails] = useState([]);
  const [FarmerData, setFarmerData] = useState(null);
  const [loading, setIsLoading] = useState(false);
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [searchKey, setSearchKey] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const isMobile = useMediaQuery("(max-width:600px)");
  const {
    data: farmerData,
    isLoading: farmerLoading,
    isFetching,
  } = useGetFarmersQuery(
    { orgId,
       page: pagination.page,
      per_page: pagination.per_page, searchKey: debouncedSearch || "" },
    { refetchOnMountOrArgChange: true }
  );

  const { data: soilData, isLoading: soilLoading } = useGetSoilParametersQuery(
    selectedFarmer?.id ? { FarmerId: selectedFarmer.id } : skipToken
  );

  useEffect(() => {
    if (farmerData?.data?.results?.length && !selectedFarmer) {
      const firstFarmer = farmerData.data.results[0];
      handleSelectFarmer(firstFarmer);
    }
  }, [farmerData]);

  useEffect(() => {
    setSoilDetails(soilData?.data?.results || []);
  }, [soilData]);

  const handleSelectFarmer = async (farmer) => {
    setSelectedFarmer(farmer);
    await fetchFarmerData(farmer.id);
  };

  const fetchFarmerData = async (farmerId) => {
    setIsLoading(true);
    const state = store.getState();
    try {
      const response = await axios.get(
        `${API_URL}/api/v1/onboarding/farmers/${farmerId}`,
        {
          headers: {
            Authorization: `Bearer ${state.auth.accessToken}`,
            "Content-Type": "application/json",
          },
        }
      );
      setFarmerData(response?.data?.data?.farm);
    } catch (error) {
      console.error("Error fetching farmer data:", error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchKey.trim() ? searchKey : "");
    }, 500); // 500ms debounce time

    return () => clearTimeout(handler);
  }, [searchKey]);

  const handleChangeSearch = (e) => {
    const value = e.target.value;
    setPagination({ page: 1, pageCount: 0, per_page: 50 });
    setSearchKey(value);
    setFarmerData("");
  };
  const getStaticAdvisory = (acs) => {
    if (acs >= 80) {
      return "Crop Health seems Very Good, No Actions are Required.";
    } else if (acs >= 70) {
      return "Crop Health seems Good but Needs to Keep Monitoring. If there is any aberration observed on the field, it can be intimated.";
    } else if (acs >= 60) {
      return "Crop Health is Good but there is a possibility of Stress so continuous monitoring is suggested.";
    } else if (acs >= 50) {
      return "Crop Health is Just fine, there is a possibility of Stress. Immediate field check is suggested.";
    } else {
      return "Crop Health is Poor, there is immediate intervention required in the context of nutrient and moisture management.";
    }
  };

  return (
    <div className=" p-2">
      <div className="d-flex flex-lg-row flex-column align-items-start gap-3 ">
        <div
          className="col-lg-3 col-12"
          style={{
            borderRight: "1px solid #e5e5e5",
            padding: "15px",
            backgroundColor: "#f9f9f9",
            height: "auto",
            flexShrink: 0,
          }}
        >
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h5 className="mb-0">Farmers</h5>
            <div style={{ width: "60%" }}>
              <input
                type="text"
                className="form-control form-control-sm"
                placeholder="Search farmers..."
                style={{
                  borderRadius: "8px",
                  padding: "8px 12px",
                  border: "1px solid #ced4da",
                  fontSize: "14px",
                }}
                onChange={handleChangeSearch}
              />
            </div>
          </div>

          {farmerLoading ? (
            <div className="text-center p-4">
              <Spinner animation="border" />
              <p className="mt-2">Loading farmers...</p>
            </div>
          ) : (
            <>
              {farmerData?.data?.results?.map((farmer) => (
                <div
                  key={farmer.FarmerId}
                  onClick={() => handleSelectFarmer(farmer)}
                  className={`d-flex align-items-center mb-3 p-2 rounded shadow-sm ${
                    selectedFarmer?.id === farmer.id
                      ? "bg-primary text-white"
                      : "bg-white"
                  }`}
                  style={{ cursor: "pointer", transition: "0.3s" }}
                >
                  <img
                    src={
                      farmer.ImageFile ||
                      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSxTYFlL3rMQGJUnGYA--ilSNhGJwCOdYr7kA&s"
                    }
                    alt={farmer.full_name}
                    className="rounded-circle me-3"
                    style={{
                      width: "50px",
                      height: "50px",
                      objectFit: "cover",
                    }}
                  />
                  <div>
                    <div className="fw-bold">{farmer.full_name}</div>
                    <small>{farmer.phone_number}</small>
                  </div>
                </div>
              ))}
            </>
          )}

          {/* Pagination */}
          <div className="d-flex justify-content-between mt-4">
            <Button
              variant="secondary"
              size="sm"
              onClick={() =>
                setPagination((prev) => ({
                  ...prev,
                  page: Math.max(prev.page - 1, 1),
                }))
              }
              disabled={pagination.page === 1}
            >
              Previous
            </Button>
            <span>Page {pagination.page}</span>
            <Button
              size="sm"
              style={{
                backgroundColor:
                  farmerData?.data?.results?.length < pagination.per_page
                    ? "#6c757d"
                    : "#ff7f50",
                borderColor:
                  farmerData?.data?.results?.length < pagination.per_page
                    ? "#6c757d"
                    : "#ff7f50",
              }}
              onClick={() =>
                setPagination((prev) => ({ ...prev, page: prev.page + 1 }))
              }
              disabled={farmerData?.data?.results?.length < pagination.per_page}
            >
              Next
            </Button>
          </div>
        </div>

        <div className="col-lg-9 col-12">
          <Card className="shadow-sm mb-4">
            <Card.Header className="d-flex justify-content-between align-items-center">
              <h5 className="mb-0">
                {selectedFarmer?.full_name} - Advisory Details
              </h5>
              {AdvisoryUrl ? (
                <span
                  onClick={() => setModalOpen(true)}
                  className="text-primary d-flex align-items-center"
                  style={{ cursor: "pointer", fontSize: "14px" }}
                >
                  <Visibility fontSize="small" className="me-1" />
                  View Advisory
                </span>
              ) : null}
            </Card.Header>

            <Card.Body className="p-lg-4 p-1">
              {loading ? (
                <div className="text-center p-5">
                  <Spinner animation="border" />
                  <p className="mt-2">Loading farm data...</p>
                </div>
              ) : FarmerData?.length ? (
                FarmerData.map((farm, idx) => {
                  const relatedSoilParams = SoilDetails.filter(
                    (plot) => plot.PlotId === farm.id
                  );
                  return (
                    <div
                      key={idx}
                      className="mb-4 p-3 border rounded shadow-sm"
                    >
                      <h5 className="mb-3 text-primary">
                        Farm {idx + 1} - {farm?.plot_name || farm.land_mark}
                      </h5>

                      <div className="row mt-4 ">
                        <div className="col-lg-8 col-12">
                          <div className="d-flex align-items-center gap-2">
                            <i className="mdi mdi-home-analytics fs-5 text-success"></i>
                            <h5 className="m-0 fw-semibold text-dark">
                              Farm Details
                            </h5>
                          </div>

                          <div className="d-lg-block d-md-block d-none">
                            <Table className="table mb-0" hover responsive>
                              <tbody>
                                <tr>
                                  <th>Plot Name :</th>
                                  <td>{farm?.plot_name || "N/A"}</td>
                                  <th className="ps-4">Land Mark :</th>
                                  <td>{farm?.land_mark || "N/A"}</td>
                                </tr>
                                {/* <tr>
                                  <th>Survey Number :</th>
                                  <td>{farm?.survey_number || "N/A"}</td>
                                  <th className="ps-4">Declared Area:</th>
                                  <td>{farm?.declared_area || "N/A"}</td>
                                </tr> */}
                                <tr>
                                  <th>Calculated Area (in acres) :</th>
                                  <td>{farm?.calculated_area || "N/A"}</td>
                                  <th className="ps-4">Cropping Pattern :</th>
                                  <td>{farm?.cropping_pattern || "N/A"}</td>
                                  {/* <th>ACS:</th>
                                  <td>{farm?.ACS || "N/A"}</td> */}
                                </tr>
                                <tr>
                                  {/* <th>Crop Health:</th>
                                  <td>{farm?.crop_health || "N/A"}</td> */}
                                </tr>
                              </tbody>
                            </Table>
                          </div>
                        </div>
                        <div className="col-lg-4 col-12">
                          <Card className="shadow-sm border-0">
                            <CardHeader
                              className="d-flex align-items-center gap-2 px-3 py-2"
                              style={{ background: "white" }}
                            >
                              <i className="mdi mdi-map fs-5 text-info"></i>
                              <h5 className="m-0 fw-semibold text-dark">
                                Farm Map
                              </h5>
                            </CardHeader>
                            <CardBody className="p-2">
                              <FarmerCropHealthMap
                                boundary={farm?.boundary}
                                acs={farm?.summary_stats?.acs}
                                height="30vh"
                                boundaryUpdated={farm.boundary_updated}
                                latLong={[
                                  farm?.central_latitude,
                                  farm?.central_longitude,
                                ]}
                              />
                            </CardBody>
                          </Card>
                        </div>
                      </div>

                      {relatedSoilParams?.length > 0 && (
                        <h5 className="m-0 fw-semibold text-dark mb-2 mx-2">
                          Soil Parameters
                        </h5>
                      )}
                      {relatedSoilParams?.length > 0
                        ? relatedSoilParams.map((plot, index) => (
                            <div
                              key={index}
                              className="mb-3 p-3 border rounded"
                              style={{ backgroundColor: "#eff0f3" }}
                            >
                              <h6>{plot.Parameters?.Time || "N/A"}</h6>
                              <div className="row g-3 mt-2">
                                <div className="col-md-3">
                                  <div className="border rounded p-2 text-center bg-white">
                                    <small className="text-muted">
                                      Moisture
                                    </small>
                                    <h5 className="mt-1 text-primary">
                                      {plot.Parameters?.moisture || "N/A"}%
                                    </h5>
                                  </div>
                                </div>
                                <div className="col-md-3">
                                  <div className="border rounded p-2 text-center bg-white">
                                    <small className="text-muted">
                                      Temperature
                                    </small>
                                    <h5 className="mt-1 text-danger">
                                      {plot.Parameters?.temperature || "N/A"}°C
                                    </h5>
                                  </div>
                                </div>
                                <div className="col-md-3">
                                  <div className="border rounded p-2 text-center bg-white">
                                    <small className="text-muted">
                                      EC Value
                                    </small>
                                    <h5 className="mt-1 text-success">
                                      {plot.Parameters?.ecValue || "N/A"}
                                    </h5>
                                  </div>
                                </div>
                                <div className="col-md-3">
                                  <div className="border rounded p-2 text-center bg-white">
                                    <small className="text-muted">
                                      PH Value
                                    </small>
                                    <h5 className="mt-1 text-success">
                                      {plot.Parameters?.pHValue || "N/A"}
                                    </h5>
                                  </div>
                                </div>
                              </div>

                              {/* NPK */}
                              <div className="mt-3 d-flex justify-content-center gap-2">
                                <Badge bg="primary">
                                  N : {plot.Parameters?.nValue || "N/A"}
                                </Badge>
                                <Badge bg="success">
                                  P : {plot.Parameters?.pValue || "N/A"}
                                </Badge>
                                <Badge bg="warning" text="dark">
                                  K : {plot.Parameters?.kValue || "N/A"}
                                </Badge>
                              </div>
                            </div>
                          ))
                        : ""}

                      <h6 className="mt-4 mb-2">Scores</h6>

                      <div className="row mt-2">
                        <div className="col-md-3 text-center">
                          <RadialSoilScoreChart
                            value={farm?.scores?.soul_score || "N/A"}
                            label="Soul Score"
                          />
                        </div>
                        {/* <div className="col-md-4 text-center">
                          
                          <FarmerReportGaugeChart
                            farmerDataCl={farm?.summary_stats?.acs}
                            chartName="Agriculture Credit Score"
                          />
                            </div> */}

                        <div className="col-md-5 text-center">
                          {(() => {
                            const latestACS =
                              Array.isArray(farm?.scores?.ACS) &&
                              farm?.scores?.ACS.length > 0 &&
                              typeof farm.scores.ACS[0] === "object"
                                ? Object.values(farm.scores.ACS[0])[0]
                                : 0;

                            return (
                              <FarmerReportGaugeChart
                                farmerDataCl={latestACS}
                                chartName="Agriculture Credit Score"
                              />
                            );
                          })()}
                        </div>

                        {/* <div className="col-md-4 text-center">
                          <FarmerProgressBarChart
                            farmerDataCl={farm?.summary_stats?.crop_health}
                            chartName="Crop Health Score"
                          />
                        </div> */}
                        <div className="col-md-3  text-center">
                          {(() => {
                            const latestHealth =
                              Array.isArray(farm?.scores?.crop_health) &&
                              farm?.scores?.crop_health.length > 0 &&
                              typeof farm.scores.crop_health[0] === "object"
                                ? Object.values(farm.scores.crop_health[0])[0]
                                : 0;

                            return (
                              <FarmerProgressBarChart
                                farmerDataCl={latestHealth}
                                chartName="Crop Health Score"
                              />
                            );
                          })()}
                        </div>
                      </div>
                      {/* <AdvisoryTextComponent
                        disclaimer={farm.scores?.disclaimer?.en}
                        advisory={farm?.scores?.advisory?.en}
                      ></AdvisoryTextComponent> */}
                      <AdvisoryTextComponent
                        disclaimer={farm.scores?.disclaimer?.en}
                        advisory={farm?.scores?.advisory?.en}
                        staticAdvisory={getStaticAdvisory(
                          Array.isArray(farm?.scores?.ACS) &&
                            farm.scores.ACS.length > 0 &&
                            typeof farm.scores.ACS[0] === "object"
                            ? Object.values(farm.scores.ACS[0])[0]
                            : 0
                        )}
                      />
                    </div>
                  );
                })
              ) : (
                <div className="text-muted text-center p-4">
                  No farm data available
                </div>
              )}
              <Modal
                show={modalOpen}
                onHide={() => setModalOpen(false)}
                size="xl"
              >
                <Modal.Header closeButton>
                  <Modal.Title className="fw-bold">
                    Advisory Preview
                  </Modal.Title>
                </Modal.Header>

                <Modal.Body>
                  <div className="contentWrapper">
                    <div className="content">
                      <iframe
                        src={AdvisoryUrl}
                        width="100%"
                        frameborder="0"
                        height="100%"
                      ></iframe>
                    </div>
                  </div>
                </Modal.Body>
              </Modal>
            </Card.Body>
          </Card>
        </div>
      </div>
    </div>
  );
};
